import {
    REQUEST_RESULT_EXPORT_DOWNLOAD,
    REQUEST_RESULT_EXPORT_DOWNLOAD_ERROR,
    REQUEST_RESULT_EXPORT_DOWNLOAD_SUCCESS
} from "./actions";

const initialState = {
    loading: false
};

export default function resultsExporter(state = initialState, action) {
    switch (action.type) {
        case REQUEST_RESULT_EXPORT_DOWNLOAD:
            return {
                loading: true
            };
        case REQUEST_RESULT_EXPORT_DOWNLOAD_SUCCESS:
            return {
                loading: false
            };
        case REQUEST_RESULT_EXPORT_DOWNLOAD_ERROR:
            return {
                loading: false
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/results-export/reducers.js